import { render } from "./areaWrite.vue?vue&type=template&id=24428198&scoped=true&ts=true"
import script from "./areaWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./areaWrite.vue?vue&type=script&lang=ts&config=true"

import "./areaWrite.vue?vue&type=style&index=0&id=24428198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24428198"]])

export default __exports__